module.exports = __webpack_public_path__ + "img/ALC500-1-EN.638df6af.jpg";